/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { noop } from 'lodash';
import { StyledTestimonialsTable } from './styles';
import { Testimonial } from './types';
import { Slider } from '../Slider';
import { TestimonialThumbnail } from '../TestimonialThumbnail';

export interface ITestimonialsTable {
  data: Testimonial[];
  className?: string;
  slider?: boolean;
}

export const TestimonialsTable = ({
  className,
  data,
  slider = true,
}: ITestimonialsTable) => {
  const [slide, setSlide] = useState(0);

  const settingsSlider = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    rows: 1,
    slidesPerRow: 1,
  };

  const settingsSliderPhoneResponsive = {
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    slidesPerRow: 1,
  };

  const settingsSliderPhabletResponsive = {
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 1,
    slidesPerRow: 1,
  };

  const settingsSliderTabletResponsive = {
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  const itemsToRender = data.map((testimonial: Testimonial, idx: number) => {
    const { image, id, name, recommendation, linkedInUrl, project, role } =
      testimonial;
    return (
      <Slider.Button key={id} onClick={noop}>
        <TestimonialThumbnail
          image={image.gatsbyImageData}
          alt={image.description}
          name={name}
          role={role}
          clientName={project.name}
          clientSlug={project.slug}
          linkedInUrl={linkedInUrl}
          recommendation={recommendation}
          slide={slide}
          displayId={id}
          idx={idx}
        />
      </Slider.Button>
    );
  });

  return (
    <StyledTestimonialsTable className={className}>
      {slider ? (
        <Slider
          settings={settingsSlider}
          responsivePhoneSettings={settingsSliderPhoneResponsive}
          responsivePhabletSettings={settingsSliderPhabletResponsive}
          responsiveTabletSettings={settingsSliderTabletResponsive}
          paginationMargin="24px"
          onChange={(currentSlide) => {
            setSlide(currentSlide);
          }}
        >
          {itemsToRender}
        </Slider>
      ) : (
        <div className="list-container">
          <div className="list">{itemsToRender}</div>
        </div>
      )}
    </StyledTestimonialsTable>
  );
};
